import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { EyeFilled } from "@ant-design/icons";

function HeadTitle({
  sourceLogo,
  styleColor,
  styleButton,
  title1,
  content,
  link,
  buttontext,
  section2,
  products,
  data,
}) {
  const navigate = useNavigate();
  return (
    <div className="header-shadow max-lg:relative rounded-2xl agrobg flex flex-col max-lg:flex-col p-4 max-lg:p-2 gap-4 max-lg:gap-0 items-center justify-between">
      <div className="flex flex-row items-center max-lg:items-center justify-start w-full gap-3 ">
        <div className="circle-neo agrobg p-1 !w-12 !h-12">
          <img alt="weathericon" src={sourceLogo} width={42} />
        </div>

        <div className="flex flex-row max-lg:flex-col gap-2 lg:w-full items-start justify-between ">
          <p
            className={`lg:text-[1.1rem] tracking-tight font-extrabold ${styleColor} whitespace-nowrap`}
          >
            {title1}
          </p>

          {link && (

            <Button
              onClick={() => navigate(link)}
              icon={<EyeFilled />}
              className={` ${styleButton} hover:brightness-105 border-none text-sm max-lg:text-[11px] max-lg:h-6 font-bold `}
            >
              {buttontext}
            </Button>

          )}
        </div>
      </div>

      <div className="flex flex-col gap-4 justify-start items-end max-lg:p-2 max-lg:gap-2">
        <p className="text-right lg:w-[50vw] text-[12px] max-lg:text-[10px] max-lg:text-justify">
          {content}
        </p>

        {section2 && (
          <p className="text-[#491086] text-right font-bold w-full">
            کشت‌های قابل انتخاب:
            <p className="text-right">
              {products?.data?.map((product, i) => {
                if (data?.includes(product?.productId)) {
                  return (
                    <span
                      className="text-[12px] font-medium text-agrotext"
                      key={i}
                    >
                      {product?.persianName}
                      {" , "}
                    </span>
                  );
                } else {
                  return null
                }
              })}
            </p>
          </p>
        )}
      </div>
    </div>
  );
}

export default HeadTitle;
